import React from 'react';
import { Skeleton } from '@mui/material';
import { useAuth } from '@/lib/auth';
import '../user.css';
import i18next from 'i18next';
import prf from '@/assets/prf.png';
import banner from '@/assets/main-banner.png';

const UserHeadBar = ({ content }: { content?: string }) => {
  const { user, isLoggingIn } = useAuth();

  return (
    <div
      className="container profileContainer prf-common relative "
      style={{ backgroundImage: 'url(' + banner + ')' }}
    >
      <div className="row p-3 profl-lft align-items-center relative">
        <div className="col-12 col-md-8 ">
          {isLoggingIn ? (
            <div>
              <Skeleton variant="rectangular" width={180} height={30}></Skeleton>
            </div>
          ) : (
            <h4 className="mb-1 text-white f-40">
              {i18next.t('Hello')} {`${user?.first_name ?? ''} ${user?.last_name ?? ''}`}
            </h4>
          )}
          <p className="mb-1 text-white">
            {content ? (
              content
            ) : (
              <>
                Your profile on REEIPO . The more information you add here, the more we can
                customize REEIPO for you.
              </>
            )}
          </p>
        </div>
        <div className="col-12 col-md-4">
          <div className="side-image">
            <img src={prf} className="side-image" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserHeadBar;
